
<template>
    <div class="box-div">
		<template v-if='!showChildrenSide'>
			<div class="index-content">
	    	   <role-son></role-son>
	       </div>
		</template>
		<template v-if="showChildrenSide">
			<div class="index-content-admin">
				<master-content></master-content>
			</div>
		</template>
	   
    </div >
    
</template>

<script>

import masterContent from './component/master.vue'
import roleSon from './component/roleType2.vue'


export default {
  name: "home",
  components: {
	  masterContent,
	  roleSon
  },
  data() {
    return {
		
		
	};
  },
  async created(){
  },
  computed:{
     roleType(){
		 let res = '2'
		 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
			 res = this.$store.state.uInfo.roleType
		 }
		 return res
	 },
	 showChildrenSide(){
         return this.$store.state.showChildrenSide
     },
  },
  mounted(){
  },
  methods: { 
    
  }
};
</script>
 <style scoped lang="less">
  #main {
    // width: 100%;
	flex:1;
    height:600px;
    margin: auto;
    margin-top: 100px
  }
.box-div{
	padding: 10px 0 0 30px;
	width: 100%;
	.index-content{
		.index-title{
			color: rgba(253, 26, 26, 0.65);
            font-size: 16px;
            margin-bottom: 10px;
		}
		
		
	}
}
</style>
